import { RefreshCwOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { refreshFailureReasonKey } from '@/Domain/components/KnowledgeBase/articleRefreshFailure';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/Domain/components/Shared/Tooltip/Tooltip';
import { cn } from '@/Domain/utils/cn';

type Props = {
  reason?: string | null;
  className?: string;
};

export const ArticleRefreshFailedBadge = ({ reason, className }: Props) => {
  const { t } = useTranslation('knowledge_base');
  const label = t('articles.list.refresh_failed.label');
  const explanation = `${t(refreshFailureReasonKey(reason))} ${t(
    'articles.list.refresh_failed.hint',
  )}`;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            data-testid="article-refresh-failed-badge"
            data-reason={reason || 'unknown'}
            title={explanation}
            aria-label={`${label}. ${explanation}`}
            tabIndex={0}
            className={cn(
              'flex items-center gap-1.5 whitespace-nowrap text-xs text-warning',
              className,
            )}
          >
            <RefreshCwOff className="h-3.5 w-3.5" />
            {label}
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p>{explanation}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
